import { render } from "./WidgetRendererPropsCmp.vue?vue&type=template&id=5bfd99ef"
import script from "./WidgetRendererPropsCmp.vue?vue&type=script&lang=js"
export * from "./WidgetRendererPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__